module.exports = __webpack_public_path__ + "static/media/body-image.b0329b97.jpg";